import { createState, useState } from '@hookstate/core';

interface CustomerContractSummaryCustomerContractListListState {
  detailDrawerOpen: boolean;
  customerId: string;
}

const initialState: CustomerContractSummaryCustomerContractListListState = {
  detailDrawerOpen: false,
  customerId: '',
};

const customerContractSummaryCustomerContractListState = createState(initialState);

export function useCustomerContractSummaryCustomerContractListState() {
  return useState(customerContractSummaryCustomerContractListState);
}
